import React from 'react';
import TablePagination from '@mui/material/TablePagination';
import {useContext, useEffect} from "react";
import {AppContext} from '../../Context/Context';

export default function UserTablePagination() {

    const {page, setPage, rowsPerPage, setRowsPerPage, count, setCount} = useContext(AppContext)

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <div className='w-[95%] m-auto'>
            <TablePagination
                component="div"
                count={count}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                showFirstButton={true}
                showLastButton={true}
            />
        </div>
    );
}
